(() => {
 'use strict';
 const init = (scope = document) => scope.querySelectorAll('[data-gang-upload]').forEach(root => {
  if (root.dataset.uploadInitialized) return;
  root.dataset.uploadInitialized = 'true';
  const form = root.querySelector('[data-gang-upload-form]');
  const select = form.querySelector('[data-upload-variant]');
  const quantity = form.querySelector('[name="quantity"]');
  const confirm = form.querySelector('[data-upload-confirm]');
  const add = form.querySelector('[data-upload-add]');
  const status = form.querySelector('[data-upload-status]');
  const error = form.querySelector('[data-upload-error]');
  const widget = form.querySelector('[data-upload-lift]');
  let queued = false;
  const uploaded = () => {
   const items=Array.from(widget.querySelectorAll('[data-filepond-item-state]'));
   return items.length>0 && items.every(item=>item.getAttribute('data-filepond-item-state')==='processing-complete') && Array.from(form.querySelectorAll('input[name^="properties["]')).some(input=>input.name!=='properties[Size confirmation]' && input.type==='hidden' && input.value.trim()!=='');
  };
  const ready = () => uploaded() && confirm.checked && select.selectedOptions[0]?.dataset.available === 'true' && quantity.validity.valid;
  const update = () => {
   queued = false;
   const option = select.selectedOptions[0];
   const total = Number(option.dataset.price) * Math.max(1,Number(quantity.value) || 1);
   const priceNode=root.querySelector('[data-upload-price]'),totalNode=root.querySelector('[data-upload-total]');
   const formatted=new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:root.dataset.currency}).format(total / 100);
   if(priceNode.textContent!==option.dataset.money)priceNode.textContent=option.dataset.money;
   if(totalNode.textContent!==formatted)totalNode.textContent=formatted;
   const mounted = !!widget.querySelector('input[type="file"]');
   const message = uploaded() ? 'Artwork uploaded. Check your sheet size and confirmation before ordering.' : mounted ? 'Upload your finished gang sheet using the field above.' : 'Loading your secure artwork uploader…';
   if (status.textContent !== message && !status.dataset.timeout) status.textContent = message;
   const disabled = !ready() || form.dataset.submitting === 'true';
   if (add.disabled !== disabled) add.disabled = disabled;
  };
  const schedule = () => {if (!queued) {queued = true;requestAnimationFrame(update);}};
  const observer = new MutationObserver(schedule);
  observer.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['value','data-filepond-item-state']});
  ['input','change','upload:added','upload:removed'].forEach(name=>form.addEventListener(name,schedule));
  select.addEventListener('change',()=>{
   const url = new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url);
   confirm.checked = false;
   form.querySelector('[data-upload-fit]').textContent = '';
   form.querySelector('[data-upload-use]').hidden = true;
   schedule();
  });
  root.querySelectorAll('[data-upload-image]').forEach(button=>button.addEventListener('click',()=>{
   const image=root.querySelector('.s2t-upload__image');image.removeAttribute('srcset');image.src=button.dataset.uploadImage;image.alt=button.dataset.uploadAlt;
   root.querySelectorAll('[data-upload-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
  const fit=form.querySelector('[data-upload-fit]');const use=form.querySelector('[data-upload-use]');
  form.querySelectorAll('[data-upload-width],[data-upload-length]').forEach(input=>input.addEventListener('input',()=>{fit.textContent='';use.hidden=true;}));
  form.querySelector('[data-upload-check]').addEventListener('click',()=>{
   const width=Number(form.querySelector('[data-upload-width]').value),length=Number(form.querySelector('[data-upload-length]').value);
   use.hidden=true;
   if (!(width>0) || !(length>0)) {fit.textContent='Enter a width and length greater than zero, in inches.';return;}
   if(width>22){fit.textContent='Your sheet is wider than 22 inches. Correct the width in your design software before uploading.';return;}
   const options=Array.from(select.options).sort((a,b)=>Number(a.dataset.length)-Number(b.dataset.length));
   const option=options.find(o=>Number(o.dataset.length)>=length);
   if(!option){fit.textContent='Your sheet is longer than 120 inches (10 feet). Shorten the layout before uploading.';return;}
   if(option.disabled){fit.textContent=`The ${option.textContent} option is unavailable. Contact S2 for help before ordering.`;return;}
   fit.textContent=`Choose ${option.textContent}. Export your final canvas at 22 × ${option.dataset.length} inches before uploading.`;
   use.dataset.variant=option.value;use.hidden=false;
  });
  use.addEventListener('click',()=>{select.value=use.dataset.variant;select.dispatchEvent(new Event('change',{bubbles:true}));select.focus();});
  // Let Upload Lift validate its own field. This additional guard cannot assess
  // physical file dimensions; it only requires the app's saved upload property.
  form.addEventListener('submit',event=>{
   if(!ready()){event.preventDefault();event.stopImmediatePropagation();error.textContent='Finish uploading, confirm your canvas size and choose a valid quantity before adding to cart.';error.hidden=false;return;}
   error.hidden=true;
  },true);
  const timer=setTimeout(()=>{if(!widget.querySelector('input[type="file"]')){status.dataset.timeout='true';status.textContent='The uploader could not load. Please refresh or contact S2 for help; do not place an order without your artwork.';}},20000);
  root._uploadCleanup=()=>{observer.disconnect();clearTimeout(timer);};
  update();
 });
 // Form-level Upload Lift validation runs before this document-level handler.
 document.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-gang-upload-form]');
  if(!form||event.defaultPrevented)return;
  event.preventDefault();
  if(form.dataset.submitting==='true')return;
  const add=form.querySelector('[data-upload-add]'),error=form.querySelector('[data-upload-error]');
  form.dataset.submitting='true';add.disabled=true;add.textContent='Adding…';error.hidden=true;
  try{
   const response=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||'Your sheet could not be added. Please try again.');
   window.location.assign('/cart');
  }catch(err){error.textContent=err.message||'Your sheet could not be added. Please try again.';error.hidden=false;form.dataset.submitting='false';add.textContent='Add to cart';form.dispatchEvent(new Event('change',{bubbles:true}));}
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-gang-upload]').forEach(root=>root._uploadCleanup?.()));
})();
